// filepath: d:\src\com.argodata.cdt.qd2.admin.muiconv\src\components\qd\questions\QuestionViewerExpandableHook.js
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import Typography from "@mui/material/Typography";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import {openDrawer} from "../../../actions/drawerActions";
import {getQuestionTemplate} from "../../../actions/questionTemplateActions";
import {removeGroupQuestion, reorderGroupQuestion} from "../../../actions/groupEditorActions";
import {removeTagQuestion} from "../../../actions/tagEditorActions";
import ArgoIconButtonHook from "../../common/ArgoIconButtonHook";
import ArgoReorderArrowsHook from "../../common/ArgoReorderArrowsHook";
import ArgoTemplateListDividerHook from "../../common/ArgoTemplateListDividerHook";
import * as TEMPLATE from "../../../constants/templateConstants";
import * as questionTypes from "../../../constants/questionTypeConstants";
import * as expander from "../../../utilities/expander";
import statusFormatter from "../../../utilities/StatusFormatter";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities";
import Box from "@mui/material/Box";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const QuestionViewerExpandableHook = (props) => {
    const [allRequiredTemplatesLoadedFromGraphFlag, setAllRequiredTemplatesLoadedFromGraphFlag] = useState(false);
    const [questionKeysArray, setQuestionKeysArray] = useState([]);
    const [questionTemplateObjects, setQuestionTemplateObjects] = useState({});

    const dispatch = useDispatch();

    // Redux state
    const questionTemplatesFromSelector = useSelector(state => state.questionTemplate);

    useEffect(() => {

        if (props.useGraph) {

            // Graphs are a constant, once loaded they will not be changed because they are NOT used on screens that have edit capabilities

            if (props.groupGraph["id"]) {
                let groupGraphClone = portalShared.cloneObj(props.groupGraph);
                let questions = groupGraphClone.questionTemplates;

                let questionKeys = [];
                let questionObjs = {};
                for (let q=0; q < questions.length; q++) {
                    questionKeys.push(questions[q].templateKey);

                    questionObjs[questions[q].templateKey] = questions[q];
                }

                setQuestionKeysArray(questionKeys);
                setQuestionTemplateObjects(questionObjs);
                setAllRequiredTemplatesLoadedFromGraphFlag(true);
            }
        } else {

            if (props.questionKeys?.length >= 0) {

                props.questionKeys.forEach(questionKey => {
                    dispatch(getQuestionTemplate(questionKey, null));
                });

                setQuestionKeysArray(props.questionKeys);
                setQuestionTemplateObjects(questionTemplatesFromSelector);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(props.questionKeys), questionTemplatesFromSelector, props.groupGraph]);

    // Helper function to set state - replaces the setStateCallback method
    // const setStateCallback = (stateObj) => {
    //     if (stateObj.hasOwnProperty('expander')) setExpanderState(stateObj.expander);
    //     //if (stateObj.hasOwnProperty('expandAll')) setExpandAll(stateObj.expandAll);
    //     if (stateObj.hasOwnProperty('expanderPreset')) setExpanderPreset(stateObj.expanderPreset);
    //     //if (stateObj.hasOwnProperty('portalPreviewRendered')) setPortalPreviewRendered(stateObj.portalPreviewRendered);
    //     //if (stateObj.hasOwnProperty('questionInfoDrawerOpen')) setQuestionInfoDrawerOpen(stateObj.questionInfoDrawerOpen);
    //     //if (stateObj.hasOwnProperty('expanderObjLoaded')) setExpanderObjLoaded(stateObj.expanderObjLoaded);
    //     if (stateObj.hasOwnProperty('widthChange')) setWidthChange(stateObj.widthChange);
    //
    //     // Pass any other state changes to parent component if needed
    //     if (props.setStateCallback) {
    //         props.setStateCallback(stateObj);
    //     }
    // };

    // Replacement for setExpander class method
    // const setExpanderFunc = (propsToUse) => {
    //     if (!expanderPreset && allRequiredTemplatesLoaded(propsToUse)) {
    //         setExpanderPreset(true);
    //         setExpanderState(expander.presetExpander(propsToUse.questionKeys, propsToUse.questionTemplates));
    //         propsToUse.setStateCallback({questionsLoaded: true, groupTemplates: propsToUse.questionTemplates});
    //     }
    // };

    // Replacement for allRequiredTemplatesLoaded class method
    // const allRequiredTemplatesLoaded = () => {
    //     let allTemplatesLoaded = (props.questionKeys.length === Object.keys(questionTemplatesFromSelector).length);
    //
    //     if (props.useGraph) {
    //         allTemplatesLoaded = allRequiredTemplatesLoadedFromGraphFlag;
    //     }
    //
    //     return allTemplatesLoaded;
    // };


    // Replacement for answerCount class method
    const answerCount = (questionTemplate) => {
        // Only radio and checkbox questions have answers, in those cases we want to display an assigned answers count
        let answerCountDisplay = "";

        if (questionTemplate.questionType === questionTypes.RADIO || questionTemplate.questionType === questionTypes.CHECKBOX ) {
            answerCountDisplay = " (Answers Assigned: " + questionTemplate.answerOptionTemplates.length + ")"
        }

        return answerCountDisplay;
    };

    // -----------------------------------------------------------------------------------------------------------------
    // EXPANDER FUNCTIONS ----------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    const onClickIconButtonReorder = (event, fieldName, index, depth, direction) => {
        event.stopPropagation(); // Keep accordion from expand/collapse

        props.reorderGroupQuestion((direction === "up"), index, props.parentTemplate);
    };

    const onClickIconButtonEdit = (questionTemplate, event) => {
        event.stopPropagation(); // Keep accordion from expand/collapse
        props.setStateCallback({openQuestionEditor: true, questionTemplate: questionTemplate});
        //props.openDrawer(questionCreateEditDrawerProps, <QuestionCreateEditDrawer templateKey={questionTemplate.templateKey} templateId={questionTemplate.id} filter={props.filter} templateMode={TEMPLATE.MODE.CURRENT}/>);
    };

    const onClickIconButtonRemove = (index, questionTemplateKey, event) => {

        event.stopPropagation(); // Keep accordion from expand/collapse

        if (props.parentType === TEMPLATE.TYPE.GROUP) {
            props.removeGroupQuestion(index);
        } else {
            let removedQuestionKey = props.questionKeys[index]; // index it the index in props.questionKeys
            props.removeTagQuestion(index);
            props.setStateCallbackRemovedQuestionListUpdate(removedQuestionKey);
        }

        props.removeQuestionCallback(questionTemplateKey);
    };

    const onClickIconButtonInfo = (questionTemplate, event) => {

        let selectedTemplate = questionTemplate; // Use template unless graph mode
        if (props.useGraph) {
            selectedTemplate = props.groupGraph.questionTemplates.find(obj => {return obj.id === questionTemplate.id});
        }

        event.stopPropagation(); // Keep accordion from expand/collapse
        props.setStateCallback({openQuestionReview: true,
            selectedQuestionInfoKey: questionTemplate.templateKey,
            selectedQuestionInfoId: questionTemplate.id,
            selectedQuestionInfoTemplate: selectedTemplate,
            hidePortalPreview: true, showGroupBackButton: false});
    };

    // Commented out in original as well
    // const onExpandChange = (questionTemplateKey) => {
    //     if(props.isLikert) return //prevents expandable from wiggling on click if is likert
    //     expander.expandCollapseSelected(expanderState, questionTemplateKey, setStateCallback);
    // };

    // -----------------------------------------------------------------------------------------------------------------
    // RENDER ----------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    const notAllTemplatesLoaded = (keys, templates) => {
        let notAllLoaded = false;

        keys.forEach((key) => {
            if (!templates[key]) {
                notAllLoaded = true;
            }
        });

        return notAllLoaded;
    };

    if (props.useGraph) {
        if (!allRequiredTemplatesLoadedFromGraphFlag) {
            return null;
        }
    }
    else if (questionKeysArray === undefined) {
        return null;
    } else if (notAllTemplatesLoaded(questionKeysArray, questionTemplateObjects)) {
        return null;
    }

    const template = props.useGraph ? props.groupGraph : (props.groupTemplate ?? {id: 123456789}); // In case in create mode

    return (
        <div key={"GroupViewerExpandable-container-div-groupId-" + template.id}
             id={"GroupViewerExpandable-container-div-groupId-" + template.id}
             style={{width: "100%"}}>

            <div>&nbsp;</div>

            {/*// ===========================================================================================================*/}
            {/*// QUESTION LIST DIVIDER */}
            {/*// ===========================================================================================================*/}

            <ArgoTemplateListDividerHook
                fileName="QuestionViewerExpandableHook"
                parentsLabel={props.parentType.charAt(0).toUpperCase() + props.parentType.slice(1)}
                childLabel={["question", "questions"]}
                arrayLength={props.questionKeys.length}
            />

            {/*// ===========================================================================================================*/}
            {/*// QUESTION EXPAND/COLLAPSE BUTTON  - NOTE: No expand/collapse button if group is Likert i.e. has answers  */}
            {/*// ===========================================================================================================*/}

            {/*Commented out because question expanders no longer expand since there is no info in them*/}
            {/*{(props.questionKeys.length > 1 && !props.isLikert) ?*/}
            {/*    <div style={{float: "right", width: 140}}>*/}
            {/*        <ArgoExpandCollapseButtonHook*/}
            {/*            fileName="QuestionViewerExpandableHook"*/}
            {/*            expandAll={expandAll}*/}
            {/*            onClick={expander.expandCollapseAll.bind(null, TEMPLATE.TYPE.QUESTION, expanderState, expandAll, props.questionKeys, props.hidePortalPreview, setStateCallback)}*/}
            {/*        />*/}

            {/*        <div>&nbsp;</div>*/}
            {/*    </div>*/}
            {/*    : ""*/}
            {/*}*/}

            {/*// ===========================================================================================================*/}
            {/*// ASSIGNED QUESTIONS LIST */}
            {/*// ===========================================================================================================*/}

            <div id={"QuestionViewerExpandable-question-list-container-div-parentId-" + props.parentTemplate.id}
                 style={{
                     display: "flex",
                     alignSelf: "flex-start",
                     flexDirection: "column",
                     width: "100%",
                     minHeight: "min-content"
                 }}>
                {questionKeysArray.map((questionTemplateKey, index) => {
                    return (
                        !questionTemplateObjects.hasOwnProperty(questionTemplateKey) ? "" :
                            <div key={questionTemplateKey + index}
                                 id={"QuestionViewerExpandable-question-container-div" + questionTemplateKey + index}
                                 style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Accordion key={"Accordion-" + questionTemplateKey + index}
                                           id={"QuestionViewerExpandable-Accordion-" + index}
                                           variant="outlined"
                                           disableGutters={true}
                                           defaultExpanded={false}
                                           expanded={false}
                                           sx={{width: "100%", minWidth: 820}}>
                                    <AccordionSummary
                                        key={"AccordionSummary-" + questionTemplateKey + index}
                                        id={"QuestionViewerExpandable-AccordionSummary-" + index}
                                        aria-controls="panel1-content"
                                        sx={{
                                            height: "30px",
                                            backgroundColor: expander.ACCORDION_BG_COLOR,
                                            "&:hover": {backgroundColor: expander.ACCORDION_BG_COLOR_HOVER},
                                            "& .MuiAccordionSummary-content": {
                                                alignItems: "center",
                                                display: "flex",
                                                gap: 1, // small spacing between groups
                                                minWidth: 0,
                                            }
                                        }}
                                    >
                                        {props.showIconButtonReorder && questionKeysArray.length > 1?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 80}}>
                                                <ArgoReorderArrowsHook
                                                    fileName="QuestionViewerExpandableHook"
                                                    fieldName="container-div"
                                                    onClick={onClickIconButtonReorder}
                                                    index={index}
                                                    arrayLength={props.questionKeys.length}
                                                    isFirst={index === 0}
                                                    isLast={index === (props.questionKeys.length - 1)}
                                                    upArrowColor={index === 0 ? expander.ICON_COLOR_HIDDEN : expander.ICON_COLOR}
                                                    downArrowColor={props.isLast ? expander.ICON_COLOR_HIDDEN : expander.ICON_COLOR}
                                                />
                                            </Box> : ""
                                        }

                                        <Box style={{display: "flex", alignItems: "center", minWidth: 34}}>
                                            <Typography>
                                                {statusFormatter(questionTemplateObjects[questionTemplateKey], 0, 0)}
                                            </Typography>
                                        </Box>

                                        <Box style={{display: "flex", alignItems: "center", minWidth: 87, flex: 1}}>
                                            <Typography variant="h6" component="div" style={{flexShrink: 0, paddingLeft: 5, minWidth: 87, color: expander.TEXT_COLOR_SECONDARY}}>Question:</Typography>
                                            <Typography variant="h6" component="div"
                                                        style={{
                                                            flex: 1,
                                                            minWidth: 0,
                                                            maxWidth: 950,
                                                            paddingLeft: 10,
                                                            color: expander.TEXT_COLOR_PRIMARY,
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}>
                                                {questionTemplateObjects[questionTemplateKey].name}
                                            </Typography>
                                        </Box>

                                        {questionTemplateObjects[questionTemplateKey].nameQualifier ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 258}}>
                                                <Typography variant="h6" component="div" style={{flexShrink: 0, paddingLeft: 5, minWidth: 83, color: expander.TEXT_COLOR_SECONDARY}}>Qualifier:</Typography>
                                                <Typography variant="subtitle1" component="div"
                                                            style={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                maxWidth: 175,
                                                                paddingLeft: 10,
                                                                color: expander.TEXT_COLOR_PRIMARY,
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis"
                                                            }}>
                                                    {questionTemplateObjects[questionTemplateKey].nameQualifier ? questionTemplateObjects[questionTemplateKey].nameQualifier : ""}
                                                </Typography>
                                            </Box> : ''
                                        }

                                        <Box style={{display: "flex", alignItems: "center", minWidth: 143}}>
                                            <Typography variant="h6" component="div" style={{flexShrink: 0, paddingLeft: 10, minWidth: 50, color: expander.TEXT_COLOR_SECONDARY}}>Type:</Typography>
                                            <Typography variant="subtitle1" component="div"
                                                        style={{
                                                            flex: 1,
                                                            minWidth: 94,
                                                            maxWidth: 94,
                                                            paddingLeft: 10,
                                                            color: expander.TEXT_COLOR_PRIMARY,
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}>
                                                {questionTypes.getLabel[questionTemplateObjects[questionTemplateKey].questionType]}
                                            </Typography>
                                        </Box>

                                        {!questionTemplateObjects[questionTemplateKey].optional ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <Typography variant="subtitle1" component="div" sx={{paddingLeft: "20px", color: expander.TEXT_COLOR_ALERT}}>
                                                    {"*required"}
                                                </Typography>
                                            </Box> :
                                            Object.entries(questionTemplateObjects).some(([key, obj]) => obj ? !obj.optional: false) ?
                                                <Box style={{display: "flex", alignItems: "center", minWidth: 87}}></Box> : ""
                                        }

                                        {questionTemplateObjects[questionTemplateKey].length > 0 ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 0}}>
                                                <Typography variant="subtitle1" component="div" style={{flexShrink: 0, paddingLeft: 10,  color: expander.TEXT_COLOR_SECONDARY}}>
                                                    {answerCount(questionTemplateObjects[questionTemplateKey])}
                                                </Typography>
                                            </Box>
                                            : ""
                                        }

                                        {props.showIconButtonEdit ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <ArgoIconButtonHook
                                                    fileName="QuestionViewerExpandableHook"
                                                    fieldName="edit"
                                                    onClick={(event) => onClickIconButtonEdit(questionTemplateObjects[questionTemplateKey], event)}
                                                    index={index}
                                                    icon={<ModeEditIcon style={{color: expander.ICON_COLOR}}/>}
                                                    display={props.showEditIconButton}
                                                />
                                            </Box> : ""
                                        }

                                        {props.showIconButtonRemove ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <ArgoIconButtonHook
                                                    fileName="QuestionViewerExpandableHook"
                                                    fieldName="remove"
                                                    onClick={(event) => onClickIconButtonRemove(index, questionTemplateKey, event)}
                                                    index={index}
                                                    icon={<HighlightOffOutlinedIcon
                                                        style={{color: expander.ICON_COLOR}}/>}
                                                    display={props.showRemoveIconButton}
                                                />
                                            </Box> : ""
                                        }

                                        {questionTemplateObjects[questionTemplateKey]?.answerOptionTemplates.some(answer => answer.importGroupKeys.length > 0) ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <ArgoIconButtonHook
                                                    fileName="QuestionViewerExpandable"
                                                    fieldName="ShowGroup"
                                                    index={index}
                                                    tooltip={`Question contains a show group.${props.parentName.includes("Category") || props.parentName.includes("Questionnaire") ? "" : "\nOpen from Questionnaire or Category screen to see it"}`}
                                                    icon={<VisibilityOffIcon style={{color: expander.ICON_COLOR}}/>}
                                                />
                                            </Box> :
                                            Object.entries(questionTemplateObjects).some(([key, obj]) => obj?.answerOptionTemplates.some(answer => answer.importGroupKeys.length > 0)) ?
                                                <Box style={{display: "flex", alignItems: "center", minWidth: 40}}></Box> : ""
                                        }

                                        {!questionTemplateObjects[questionTemplateKey].currentFlag ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <ArgoIconButtonHook
                                                    fileName="CategoryViewerExpandable"
                                                    fieldName="CurrentFlag"
                                                    index={index}
                                                    tooltip="Not the current version"
                                                    icon={<FlagCircleIcon style={{color: "#E84343"}}/>}
                                                />
                                            </Box> :
                                            Object.entries(questionTemplateObjects).some(([key, obj]) => obj ? !obj.currentFlag: false) ?
                                                <Box style={{display: "flex", alignItems: "center", minWidth: 40}}></Box> : ""
                                        }

                                        {props.showIconButtonInfo ?
                                            <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                                <ArgoIconButtonHook
                                                    fileName="QuestionViewerExpandableHook"
                                                    fieldName="info"
                                                    onClick={(event) => onClickIconButtonInfo(questionTemplateObjects[questionTemplateKey], event)}
                                                    index={index}
                                                    tooltip="Show Details"
                                                    icon={<InfoOutlinedIcon
                                                        style={{color: expander.ICON_COLOR}}/>}
                                                />
                                            </Box>  : ""
                                        }
                                    </AccordionSummary>
                                </Accordion>
                            </div>
                    );
                })}
            </div>

        </div>

    );
};

QuestionViewerExpandableHook.defaultProps = {
    parentType: TEMPLATE.TYPE.GROUP,
    parentTemplate: {},
    showIconButtonReorder: true,
    showIconButtonEdit: true,
    showIconButtonRemove: true,
    showIconButtonInfo: true,
    setStateCallback: function () {},
    setStateCallbackRemovedQuestionListUpdate: function () {},
    hidePortalPreview: false,
    useGraph: false,
    removeQuestionCallback: function () {}
};

QuestionViewerExpandableHook.propTypes = {
    parentType: PropTypes.string,
    parentTemplate: PropTypes.object,
    questionKeys: PropTypes.array,
    questionTemplate: PropTypes.object, // Added to force re-render after edit from an expandable
    showIconButtonReorder: PropTypes.bool,
    showIconButtonEdit: PropTypes.bool,
    showIconButtonRemove: PropTypes.bool,
    showIconButtonInfo: PropTypes.bool,
    setStateCallback: PropTypes.func,
    setStateCallbackRemovedQuestionListUpdate: PropTypes.func,
    hidePortalPreview: PropTypes.bool,
    useGraph: PropTypes.bool,
    groupGraph: PropTypes.object,
    removeQuestionCallback: PropTypes.func
};

function mapStateToProps(state) {
    return {
        questionTemplates: state.questionTemplate,
        questionsFilter: state.filter[TEMPLATE.FILTER.current.question],
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getQuestionTemplate, removeTagQuestion, removeGroupQuestion, reorderGroupQuestion, openDrawer}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionViewerExpandableHook);